import { FC } from 'react'

const Payments: FC = () => {
  return <>Payments</>
}

export default Payments
